import { Component, HostListener, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import AOS from 'aos';  // Asegúrate de importar AOS
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-premiosaniversario',
  templateUrl: './premiosaniversario.component.html',
  styleUrls: ['./premiosaniversario.component.scss']
})
export class PremiosaniversarioComponent implements OnInit {
  urlMicrositioAniv = environment.URL_MICROSITIO_ANIV;
  
  isSmallScreen: boolean;
  premios = [
    {
      id: 'carSlider1',
      titulo: '1º PREMIO',
      nombre: 'AUDI Q7',
      //modelo: 'MODELO 2024',
      precioBoleto: 700,
      valor: 1770743.00,
      imagenes: [

        'https://www.youtube.com/embed/xPGmZhA2g3k',
        '/assets/images/sorteo2025/autos/car1.jpg',
      ]
    },
    {
      id: 'carSlider2',
      titulo: '2º PREMIO',
      nombre: 'BYD TANG EV',
      //modelo: 'MODELO 2024',
      precioBoleto: 700,
      imagenes: [
        'https://www.youtube.com/embed/6I_ghjZRFt4',
        '/assets/images/sorteo2025/autos/car2.jpg',
      ]
    },
    {
      id: 'carSlider3',
      titulo: '3º PREMIO',
      nombre: 'AUDI Q3',
      //modelo: 'MODELO 2024',
      precioBoleto: 700,
      imagenes: [
        'https://www.youtube.com/embed/I0zeKMUM4YU',
        '/assets/images/sorteo2025/autos/car3.jpg',
      ]
    },
    {
      id: 'carSlider4',
      titulo: '4º Y 5º PREMIO',
      nombre: 'BYD YUAN PRO',
      //modelo: 'MODELO 2024',
      precioBoleto: 700,
      imagenes: [
        'https://www.youtube.com/embed/96uBowWBpFA',
        '/assets/images/sorteo2025/autos/car4.jpg',
      ]
    },
    {
      id: 'carSlider5',
      titulo: '6º AL 8º PREMIO',
      nombre: 'BYD KING DM',
      //modelo: 'MODELO 2024',
      precioBoleto: 700,
      imagenes: [
        'https://www.youtube.com/embed/_xtNsQBhv9o',
        '/assets/images/sorteo2025/autos/car5.jpg',
      ]
    },
    {
      id: 'carSlider6',
      titulo: '9º Y 10º PREMIO',
      nombre: 'BYD dolphin MINI',
      //modelo: 'MODELO 2024',
      precioBoleto: 700,
      imagenes: [
        'https://www.youtube.com/embed/1lR6lBL-X9c',
        '/assets/images/sorteo2025/autos/car6.jpg',

      ]
    }
  ];
  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.isSmallScreen = window.innerWidth <= 767;
    window.addEventListener('resize', this.onResize.bind(this));
    // setTimeout(() => {
    //   document.querySelector(".byd").classList.add("animate-bounce");
    //   document.querySelector(".bmw").classList.add("animate-bounce2");
    // }, 2400);

    AOS.init({
      once: true,  // Para que las animaciones se activen solo una vez
      startEvent: 'load',  // Asegura que las animaciones inicien al cargar la página
    });

    // Fuerza la actualización de AOS para que se apliquen las animaciones de inmediato
    AOS.refresh();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isSmallScreen = window.innerWidth <= 767;
  }

  getVideoId(url: string): string {
    const videoId = url.split('/').pop(); // Aquí extraemos el ID del video
    return videoId;
  }

}
